import { render, staticRenderFns } from "./ArchiveCustomerReport.vue?vue&type=template&id=1039222c&"
import script from "./ArchiveCustomerReport.vue?vue&type=script&lang=js&"
export * from "./ArchiveCustomerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports